/* ==========================================================================
   RENACE LABS — comportamiento de las secciones
   Todo se inicializa por data-attributes y es idempotente:
   funciona con carga normal y con los eventos del editor de Shopify.
   ========================================================================== */
(function () {
  'use strict';

  // Cada sección incluye el <script>. Si ya se ejecutó una vez, salimos:
  // así podés dejar los renders por sección o mover el asset a theme.liquid.
  if (window.RenaceLabs) return;

  var init = {};

  /* ---------------------------------------------------- header sticky ---- */
  init.header = function (root) {
    root.querySelectorAll('[data-rl-header]').forEach(function (header) {
      if (header.dataset.rlReady) return;
      header.dataset.rlReady = '1';

      var burger = header.querySelector('[data-rl-burger]');
      if (burger) {
        burger.addEventListener('click', function () {
          var open = header.classList.toggle('is-open');
          burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }

      var onScroll = function () {
        header.classList.toggle('is-stuck', window.scrollY > 8);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    });
  };

  /* ------------------------------------------ desplegables del menú ------ */
  init.dropdown = function (root) {
    var isDesktop = function () { return window.matchMedia('(min-width: 901px)').matches; };

    root.querySelectorAll('[data-rl-dropdown]').forEach(function (item) {
      if (item.dataset.rlReady) return;
      item.dataset.rlReady = '1';

      var toggle = item.querySelector('.rl-nav__toggle');
      var panel = item.querySelector('.rl-nav__panel');
      if (!toggle || !panel) return;

      var open = function (state) {
        item.classList.toggle('is-open', state);
        toggle.setAttribute('aria-expanded', state ? 'true' : 'false');
        panel.hidden = !state;
      };

      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        // En desktop el hover ya lo abrió: si el clic alternara, cerraría el
        // panel justo cuando el usuario va a elegir una opción. Ahí el clic
        // solo abre y el cierre queda a cargo del mouseleave o del clic fuera.
        if (isDesktop()) open(true);
        else open(panel.hidden);
      });

      // En desktop además abre al pasar el mouse. El ::before del panel cubre
      // el hueco entre el botón y el panel para que no se cierre al cruzarlo.
      item.addEventListener('mouseenter', function () { if (isDesktop()) open(true); });
      item.addEventListener('mouseleave', function () { if (isDesktop()) open(false); });

      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !panel.hidden) { open(false); toggle.focus(); }
      });

      document.addEventListener('click', function (e) {
        if (!item.contains(e.target) && !panel.hidden) open(false);
      });
    });
  };

  /* ------------------------------------------------ buscador del header -- */
  init.search = function (root) {
    root.querySelectorAll('[data-rl-search]').forEach(function (box) {
      if (box.dataset.rlReady) return;
      box.dataset.rlReady = '1';

      var header = box.closest('[data-rl-header]') || document;
      var toggle = header.querySelector('[data-rl-search-toggle]');
      var close = box.querySelector('[data-rl-search-close]');
      var input = box.querySelector('input[type="search"]');

      var show = function (state) {
        box.hidden = !state;
        if (toggle) toggle.setAttribute('aria-expanded', state ? 'true' : 'false');
        if (state && input) input.focus();
      };

      if (toggle) toggle.addEventListener('click', function () { show(box.hidden); });
      if (close) close.addEventListener('click', function () { show(false); if (toggle) toggle.focus(); });
      box.addEventListener('keydown', function (e) { if (e.key === 'Escape') { show(false); if (toggle) toggle.focus(); } });
    });
  };

  /* ------------------------------------------- rotador de anuncios ------- */
  init.announce = function (root) {
    root.querySelectorAll('[data-rl-announce]').forEach(function (bar) {
      if (bar.dataset.rlReady) return;
      bar.dataset.rlReady = '1';

      var items = bar.querySelectorAll('.rl-announce__item');
      if (items.length < 2) return;
      var speed = parseInt(bar.dataset.rlAnnounce, 10) || 4000;
      var i = 0;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, speed);
    });
  };

  /* ------------------------------------ marquesina: duplica el grupo ----- */
  init.marquee = function (root) {
    root.querySelectorAll('[data-rl-marquee]').forEach(function (m) {
      if (m.dataset.rlReady) return;
      m.dataset.rlReady = '1';

      var track = m.querySelector('.rl-marquee__track');
      var group = track && track.querySelector('.rl-marquee__group');
      if (!group) return;
      // Un clon exacto permite que translateX(-50%) haga el loop perfecto.
      track.appendChild(group.cloneNode(true));
    });
  };

  /* ------------------------------------------ video con placeholder ------ */
  init.video = function (root) {
    root.querySelectorAll('[data-rl-video]').forEach(function (box) {
      if (box.dataset.rlReady) return;
      box.dataset.rlReady = '1';

      var btn = box.querySelector('[data-rl-play]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var embed = box.dataset.rlEmbed;   // URL de iframe (YouTube/Vimeo)
        var native = box.querySelector('video');
        box.classList.add('is-playing');

        if (native) { native.controls = true; native.play(); return; }
        if (embed) {
          var iframe = document.createElement('iframe');
          iframe.src = embed + (embed.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
          iframe.allow = 'autoplay; fullscreen; picture-in-picture';
          iframe.setAttribute('allowfullscreen', '');
          iframe.title = box.dataset.rlTitle || 'Video';
          box.appendChild(iframe);
        }
      });
    });
  };

  /* ------------------------------------------- selector de planes -------- */
  init.plans = function (root) {
    root.querySelectorAll('[data-rl-plans]').forEach(function (group) {
      if (group.dataset.rlReady) return;
      group.dataset.rlReady = '1';

      var plans = group.querySelectorAll('.rl-plan');
      var cta = document.getElementById(group.dataset.rlPlans || '');

      var select = function (plan) {
        plans.forEach(function (p) { p.classList.toggle('is-selected', p === plan); });
        var input = plan.querySelector('input');
        if (input) input.checked = true;
        if (cta && plan.dataset.rlUrl) cta.setAttribute('href', plan.dataset.rlUrl);
        if (cta && plan.dataset.rlCtaText) cta.textContent = plan.dataset.rlCtaText;
      };

      plans.forEach(function (plan) {
        plan.addEventListener('click', function () { select(plan); });
        plan.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(plan); }
        });
      });

      var pre = group.querySelector('.rl-plan.is-selected') || plans[0];
      if (pre) select(pre);
    });
  };

  /* ----------------------------------------------------------- FAQ ------- */
  init.faq = function (root) {
    root.querySelectorAll('[data-rl-faq]').forEach(function (faq) {
      if (faq.dataset.rlReady) return;
      faq.dataset.rlReady = '1';

      faq.querySelectorAll('.rl-faq__q').forEach(function (q) {
        q.addEventListener('click', function () {
          var item = q.closest('.rl-faq__item');
          var open = item.classList.toggle('is-open');
          q.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    });
  };

  /* ------------------------------------------------ galería producto ----- */
  init.gallery = function (root) {
    root.querySelectorAll('[data-rl-gallery]').forEach(function (gal) {
      if (gal.dataset.rlReady) return;
      gal.dataset.rlReady = '1';

      var main = gal.querySelector('[data-rl-gallery-main] img');
      var slides = gal.querySelectorAll('.rl-pdp2__slide');
      var THUMBS = '.rl-pdp__thumb, .rl-pdp2__thumb';

      gal.querySelectorAll(THUMBS).forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          gal.querySelectorAll(THUMBS).forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');

          // Galería nueva: las fotos ya están todas en el DOM y solo se
          // alterna cuál se ve. Así en celular la misma pista sirve de
          // carrusel deslizable sin duplicar el marcado.
          if (thumb.dataset.rlSlide !== undefined && slides.length) {
            var i = parseInt(thumb.dataset.rlSlide, 10);
            slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
            return;
          }

          // Galería vieja (rl-product-hero): se cambia el src de una sola foto.
          var img = thumb.querySelector('img');
          if (main && img) {
            main.src = img.dataset.rlFull || img.src;
            main.srcset = '';
            main.alt = img.alt || '';
          }
        });
      });
    });
  };

  /* ------------------------------- cantidad (comprá más, ahorrá más) ----- */
  init.tiers = function (root) {
    root.querySelectorAll('[data-rl-tiers]').forEach(function (group) {
      if (group.dataset.rlReady) return;
      group.dataset.rlReady = '1';

      var tiers = group.querySelectorAll('.rl-tier');
      var form = group.closest('form');
      var variantInput = form ? form.querySelector('[data-rl-variant-input]') : null;

      var select = function (tier) {
        tiers.forEach(function (t) {
          var on = t === tier;
          t.classList.toggle('is-selected', on);
          t.setAttribute('aria-checked', on ? 'true' : 'false');
          var i = t.querySelector('input');
          if (i) i.checked = on;
        });
        // Solo pisamos la variante si el bloque trae un ID cargado.
        var id = tier.dataset.rlVariant;
        if (variantInput && id) variantInput.value = id;
      };

      tiers.forEach(function (tier) {
        tier.addEventListener('click', function () { select(tier); });
        tier.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(tier); }
        });
      });

      var pre = group.querySelector('.rl-tier.is-selected') || tiers[0];
      if (pre) select(pre);
    });
  };

  /* ------------------------------------ suscripción vs. compra única ----- */
  init.buybox = function (root) {
    root.querySelectorAll('[data-rl-buy]').forEach(function (group) {
      if (group.dataset.rlReady) return;
      group.dataset.rlReady = '1';

      var opts = group.querySelectorAll('.rl-buyopt');
      var select = function (opt) {
        opts.forEach(function (o) {
          var on = o === opt;
          o.classList.toggle('is-selected', on);
          o.setAttribute('aria-checked', on ? 'true' : 'false');
          var i = o.querySelector('input');
          if (i) i.checked = on;
        });
      };

      opts.forEach(function (opt) {
        opt.addEventListener('click', function () { select(opt); });
        opt.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(opt); }
        });
      });
    });
  };

  /* --------------------------------------- acordeón de beneficios -------- */
  init.benefacc = function (root) {
    root.querySelectorAll('[data-rl-benefacc]').forEach(function (list) {
      if (list.dataset.rlReady) return;
      list.dataset.rlReady = '1';

      list.querySelectorAll('.rl-benefacc__q').forEach(function (q) {
        q.addEventListener('click', function () {
          var item = q.closest('.rl-benefacc__item');
          var willOpen = !item.classList.contains('is-open');
          // Acordeón de a uno: abrir cierra el resto.
          list.querySelectorAll('.rl-benefacc__item').forEach(function (i) {
            i.classList.remove('is-open');
            var b = i.querySelector('.rl-benefacc__q');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
          if (willOpen) { item.classList.add('is-open'); q.setAttribute('aria-expanded', 'true'); }
        });
      });
    });
  };

  /* --------------------------------------------- barra móvil sticky ------ */
  init.stickybar = function (root) {
    root.querySelectorAll('[data-rl-stickybar]').forEach(function (bar) {
      if (bar.dataset.rlReady) return;
      bar.dataset.rlReady = '1';

      var onScroll = function () {
        bar.classList.toggle('is-visible', window.scrollY > window.innerHeight * 0.6);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    });
  };

  /* ------------------------------------ puntos de los carruseles --------- */
  init.dots = function (root) {
    root.querySelectorAll('[data-rl-carousel]').forEach(function (track) {
      if (track.dataset.rlReady) return;
      track.dataset.rlReady = '1';

      var items = Array.prototype.slice.call(track.children);
      if (items.length < 2) return;

      var dots = document.createElement('div');
      dots.className = 'rl-dots';
      dots.setAttribute('role', 'tablist');

      items.forEach(function (item, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Ir al elemento ' + (i + 1));
        b.addEventListener('click', function () {
          // scrollIntoView movería la página entera; scrollLeft solo la pista.
          track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
        dots.appendChild(b);
      });

      track.parentNode.insertBefore(dots, track.nextSibling);

      var marcar = function () {
        var centro = track.scrollLeft + track.clientWidth / 2;
        var activo = 0, min = Infinity;
        items.forEach(function (item, i) {
          var c = item.offsetLeft - track.offsetLeft + item.offsetWidth / 2;
          var d = Math.abs(c - centro);
          if (d < min) { min = d; activo = i; }
        });
        Array.prototype.forEach.call(dots.children, function (b, i) {
          b.classList.toggle('is-active', i === activo);
        });
      };

      track.addEventListener('scroll', function () {
        window.clearTimeout(track._rlDotTimer);
        track._rlDotTimer = window.setTimeout(marcar, 60);
      }, { passive: true });
      marcar();
    });
  };

  /* ------------------------------------------- reveal al hacer scroll ---- */
  init.reveal = function (root) {
    var nodes = root.querySelectorAll('.rl-reveal:not([data-rl-ready])');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    nodes.forEach(function (n) { n.dataset.rlReady = '1'; io.observe(n); });
  };

  /* -------------------------------------------------------- arranque ----- */
  function boot(root) {
    root = root || document;
    Object.keys(init).forEach(function (k) {
      try { init[k](root); } catch (err) { console.warn('[renace] ' + k, err); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  // Editor de temas de Shopify: re-inicializa la sección recargada.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });

  window.RenaceLabs = { boot: boot };
})();
